export enum OfferAwardStatusValues {
  NotMarked = "NOT_MARKED",
  NotConsidered = "NOT_CONSIDERED",
  Awarded = "AWARDED",
}

export type OfferAwardStatus = OfferAwardStatusValues;
